import {useState} from 'react';

export const useMobileView = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 600);

  return {isMobileView, setIsMobileView};
};
